import React from "react";

// Captured from the live misefamilymeals.ca on Oct 29 2026.
export const FAMILY_MEALS_SCREENS = {
  hero: "/images/screens/family-meals/hero.jpg",
  rescueBoard: "/images/screens/family-meals/rescue-board.jpg",
  communityNeeds: "/images/screens/family-meals/community-needs.jpg",
  map: "/images/screens/family-meals/map.jpg",
  impact: "/images/screens/family-meals/impact.jpg",
};

export const HOH_SCREENS = {
  sales: "/images/screens/hoh/sales.png",
  dashboard: "/images/screens/hoh/dashboard.png",
  recipe: "/images/screens/hoh/recipe.png",
  menuRanked: "/images/screens/hoh/menu-ranked.png",
  menuOverview: "/images/screens/hoh/menu-overview.png",
};

/**
 * BrowserFrame – wraps a wide web screenshot in a subtle dark browser-style chrome.
 * Use for misekitchen.ca screenshots on the marketing site.
 */
const BrowserFrame = ({ src, alt = "misekitchen.ca screenshot", caption, className = "", testId, url = "misekitchen.ca", loading = "lazy" }) => (
  <figure className={className} data-testid={testId}>
    <div className="overflow-hidden rounded-2xl border border-[#444444] bg-[#0d0d0d] shadow-[0_30px_60px_-20px_rgba(0,0,0,0.6)]">
      <div className="flex items-center gap-1.5 px-4 py-3 border-b border-[#242424] bg-[#161616]">
        <span className="h-2.5 w-2.5 rounded-full bg-[#3a3a3a]" aria-hidden />
        <span className="h-2.5 w-2.5 rounded-full bg-[#3a3a3a]" aria-hidden />
        <span className="h-2.5 w-2.5 rounded-full bg-[#3a3a3a]" aria-hidden />
        <span className="ml-3 text-[11px] text-white/40 tracking-wide font-mono">{url}</span>
      </div>
      <img
        src={src}
        alt={alt}
        loading={loading}
        className="block w-full h-auto select-none"
        draggable={false}
      />
    </div>
    {caption && (
      <figcaption className="mt-4 text-sm text-white/60 leading-snug">{caption}</figcaption>
    )}
  </figure>
);

export default BrowserFrame;
